<template>
    <div>
        <h4>{{ $t('monitoring.tabs_label__financial_report') }}</h4>
        <p>{{ $t('monitoring.subtitle__financial_report') }}</p>
        <h4><b>{{ $t('monitoring.title__financial_report_reminder') }}</b></h4>
        <div class="report-info-box">
            <p>{{ $t('monitoring.info_box__financial_report_reminder_title') }}</p>
            <p>{{ $t('monitoring.info_box__financial_report_reminder_line_1') }}</p>
            <p>{{ $t('monitoring.info_box__financial_report_reminder_line_2') }}</p>
            <p>{{ $t('monitoring.info_box__financial_report_reminder_line_3') }}</p>
        </div>
        <div class="col-lg-4">
            <!-- Start & End date -->
            <div class="row">
                <!-- Starting date -->
                <div class="col-lg-6">
                    <base-input
                        name="report.start_date"
                        v-model="MonitoringForm.report.start_date"
                        :error="getError('report.start_date')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.technical__1_startdate')"
                        :placeholder="$t('medium_grant.technical__1_startdate')"
                        >
                        <label>{{$t('medium_grant.technical__1_startdate')}}</label>
                        <el-date-picker
                            type="date"
                            v-model="startDate"
                            :placeholder="$t('medium_grant.technical__1_startdate')"
                            >
                        </el-date-picker>
                    </base-input>
                </div>

                <!-- Ending date -->
                <div class="col-lg-6">
                    <base-input
                        name="report.end_date"
                        v-model="MonitoringForm.report.end_date"
                        :placeholder="$t('medium_grant.technical__1_enddate')"
                        :error="getError('report.end_date')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.technical__1_enddate')"
                        >
                        <label>{{$t('medium_grant.technical__1_enddate')}}</label>
                        <el-date-picker
                            type="date"
                            v-model="endDate"
                            :placeholder="$t('medium_grant.technical__1_enddate')"
                            >
                        </el-date-picker>
                    </base-input>
                </div>
            </div>
        </div>

        <upload-file
            v-if="MonitoringForm.initialized"
            :key="'financial.report'"
            v-model="MonitoringForm.files.financial.report"
            section="financial.report"
            class="upload-report-box"
            :file-data="MonitoringForm.files.financial.report"
            :is-editable="MonitoringForm.isEditable"
            :model-name="'MonitoringReport'"
            :size-limit="MonitoringForm.fileSizeLimit"
            @file="fileAdded"
            >
            <div class="row">
                <div class="col-lg-12 upload-report-inner-box">
                    <h4>{{ $t('monitoring.button_title__upload_report') }}</h4>
                </div>
            </div>
        </upload-file>

        <h4 class="mt-supporting-docs-title"><b>{{ $t('monitoring.title__supporting_documents') }}</b></h4>
        <a :href="guidanceFile"
            class="ml-2 btn btn-simple btn-primary"
            >
            {{$t('monitoring.download_guidance_reporting_documents')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <base-button
            v-if="!MonitoringForm.report.show_supporting_documents"
            type="primary"
            class="add-supporting-documents"
            @click="showSupportingDocuments"
            >
            {{ $t('monitoring.button_title__add_supporting_documents') }}
        </base-button>

        <div class="row monitoring-support-documents" v-if="MonitoringForm.report.show_supporting_documents && !MonitoringForm.new_report ">
            <div class="col-lg-8" v-bind:class="{'msd-expanded': (expandedSelector == group_title)}" v-for="(group, group_title, group_index) in supportingDocs" :key="group_title">
                <h3 class="card-title" @click="expandedSelector = group_title">{{ $t(group_title) }}</h3>

                <base-button
                    v-show="(expandedSelector === group_title)"
                    type="primary"
                    class="add-new-document group_download"
                    @click="groupDownload(group_title.toLowerCase().replace('monitoring.supporting_docs_group_title__', ''),group_index)"
                >
                <i class="fas fa-download"></i>
                   <span class="pl-2"> {{$t('general.download')}}  {{$t(group_title)}} </span>
                </base-button>

                <div class="msd-group-inner">
                    <div class="msd-subgroup" v-for="(subgroup, title) in group" :key="title">
                        <span class="msd-remove-group tim-icons icon-trash-simple" @click="removeSupportGroup(group, title)" v-if="MonitoringForm.isEditable && subgroup.custom_group"></span>
                        <h4 class="card-title">{{ $t(subgroup.title) }}</h4>
                        <div class="form-group file-group" v-for="(field, index) in subgroup.fields" :key="'field_' + index">
                            <span class="file-caption">{{ field }}</span>
                            <div v-if="field">
                                <upload-file
                                    v-if="MonitoringForm.initialized"
                                    :key="'upload_' + index"
                                    v-model="MonitoringForm.files.financial['support_document_' + (title + '_' + field).toLowerCase().replace(/\s|\./gi, '_').replace('_upload_here', '')]"
                                    class="upload-file"
                                    :section="'financial.support_document_' + (title + '_' + field).toLowerCase().replace(/\s|\./gi, '_').replace('_upload_here', '')"
                                    :file-data="MonitoringForm.files.financial['support_document_' + (title + '_' + field).toLowerCase().replace(/\s|\./gi, '_').replace('_upload_here', '')]"
                                    :is-editable="MonitoringForm.isEditable"
                                    :model-name="'MonitoringReport'"
                                    :size-limit="MonitoringForm.fileSizeLimit"
                                    @file="fileAdded"
                                >
                                </upload-file>
                            </div>
                        </div>
                        <div class="form-group file-group" v-for="(field, index) in subgroup.custom_fields" :key="'custom_field_' + index">
                            <input class="msd-field-title" type="text" v-model="field.title" />
                            <upload-file
                                v-if="MonitoringForm.initialized"
                                :key="'custom_field_upload_' + index"
                                v-model="MonitoringForm.files.financial[field.key]"
                                class="upload-file"
                                :section="'financial.' + field.key"
                                :file-data="MonitoringForm.files.financial[field.key]"
                                :is-editable="MonitoringForm.isEditable"
                                :model-name="'MonitoringReport'"
                                :size-limit="MonitoringForm.fileSizeLimit"
                                @file="fileAdded"
                            >
                            </upload-file>
                            <span class="msd-remove-item tim-icons icon-trash-simple" @click="removeSupportField(subgroup, index)" v-if="MonitoringForm.isEditable"></span>
                        </div>
                        <base-button
                            v-if="MonitoringForm.isEditable"
                            type="primary"
                            class="add-new-document"
                            @click="addNewSupportingDocument(subgroup, group_index)"
                            >
                            {{ $t('monitoring.button_title__add_new_document') }}
                        </base-button>
                        <base-button
                            v-if="MonitoringForm.isEditable"
                            type="primary"
                            class="add-new-document"
                            @click="addSupportingDocumentGroup(group, subgroup.title, subgroup)"
                            >
                            {{ $t('monitoring.button_title__add_documents_group') }}
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row monitoring-support-documents" v-if="MonitoringForm.report.show_supporting_documents && MonitoringForm.new_report ">
            <div class="col-lg-8" v-bind:class="{'msd-expanded': (expandedSelector == group_title)}" v-for="(group, group_title, group_index) in newsupportingDocs" :key="group_title">
                <h3 class="card-title" @click="expandedSelector = group_title">{{ $t(group_title) }}</h3>

                <base-button
                    v-show="(expandedSelector === group_title)"
                    type="primary"
                    class="add-new-document group_download"
                    @click="newDocGroupDownload(group_title.toLowerCase().replace('monitoring.supporting_docs_group_title__', ''),group_index)"
                >
                <i class="fas fa-download"></i>
                   <span class="pl-2"> {{$t('general.download')}}  {{$t(group_title)}} </span>
                </base-button>

                <div class="msd-group-inner">
                    <div class="msd-subgroup" v-for="(subgroup, title) in group" :key="title">
                        <span class="msd-remove-group tim-icons icon-trash-simple" @click="removeSupportGroup(group, title)" v-if="MonitoringForm.isEditable && subgroup.custom_group"></span>
                        <h4 class="card-title">{{ $t(subgroup.title) }}</h4>
                        <div class="form-group file-group" v-for="(field, index) in subgroup.fields" :key="'field_' + index">
                            <span class="file-caption">{{ field }}</span>
                            <div v-if="field">
                                <upload-file
                                    v-if="MonitoringForm.initialized"
                                    :key="'upload_' + index"
                                    v-model="MonitoringForm.files.financial['support_document_' + group_index + '_' + title + '_' + index + field.toLowerCase().replace(/\s|\./gi, '_').replace('upload_here', '')]"
                                    class="upload-file"
                                    :section="'financial.support_document_' + group_index + '_' + title + '_' + index + field.toLowerCase().replace(/\s|\./gi, '_').replace('upload_here', '')"
                                    :file-data="MonitoringForm.files.financial['support_document_' + group_index + '_' + title + '_' + index + field.toLowerCase().replace(/\s|\./gi, '_').replace('upload_here', '')]"
                                    :is-editable="MonitoringForm.isEditable"
                                    :model-name="'MonitoringReport'"
                                    :size-limit="MonitoringForm.fileSizeLimit"
                                    @file="fileAdded"
                                >
                                </upload-file>
                            </div>
                        </div>
                        <div class="form-group file-group" v-for="(field, index) in subgroup.custom_fields" :key="'custom_field_' + index">
                            <input class="msd-field-title" type="text" v-model="field.title" />
                            <upload-file
                                v-if="MonitoringForm.initialized"
                                :key="'custom_field_upload_' + index"
                                v-model="MonitoringForm.files.financial[field.key]"
                                class="upload-file"
                                :section="'financial.' + field.key"
                                :file-data="MonitoringForm.files.financial[field.key]"
                                :is-editable="MonitoringForm.isEditable"
                                :model-name="'MonitoringReport'"
                                :size-limit="MonitoringForm.fileSizeLimit"
                                @file="fileAdded"
                            >
                            </upload-file>
                            <span class="msd-remove-item tim-icons icon-trash-simple" @click="removeSupportField(subgroup, index)" v-if="MonitoringForm.isEditable"></span>
                        </div>
                        <base-button
                            v-if="MonitoringForm.isEditable"
                            type="primary"
                            class="add-new-document"
                            @click="addNewSupportingDocument(subgroup, group_index)"
                            >
                            {{ $t('monitoring.button_title__add_new_document') }}
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {MonitoringService, UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from '@/event-bus.js';
    import {DatePicker} from 'element-ui';
    import swal from 'sweetalert2';
    import Multiselect from 'vue-multiselect';
    import BaseButton from '../../../../components/BaseButton.vue';

    export default
    {
        components:
        {
            MonitoringForm,
            [DatePicker.name]: DatePicker,
            Multiselect,
            BaseButton
        },
        data()
        {
            return {
                UserRoles,
                MonitoringForm,
                loggedUser: {},
                guidanceFile: '/files/en/MG/MG_Biopama_Reporting-template_GENERIC_Year-1.xlsx',
                // guidanceFile: '/files/en/MG/Guidance on Reporting Documents in case of Simplified Cost Option-MG.xlsx',
                startDate: '',
                endDate: '',
                expandedSelector: '',
                reportId: parseInt(this.$route.params.reportId) || null,
            }
        },
        computed:
        {
            supportingDocs: function ()
            {
                 let data = {
                    'monitoring.supporting_docs_group_title__human_resources': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__human_resources'],
                    'monitoring.supporting_docs_group_title__travel': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__travel'],
                    'monitoring.supporting_docs_group_title__equipment_supplies': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__equipment_supplies'],
                    'monitoring.supporting_docs_group_title__other_costs_services': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__other_costs_services'],
                    'monitoring.supporting_docs_group_title__other': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__other'],
                };

                return data;
            },

            newsupportingDocs: function()
            {
                let data = {
                    'monitoring.supporting_docs_group_title__travel_and_subsistence': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__travel_and_subsistence'],
                    'monitoring.supporting_docs_group_title__costs_and_services': MonitoringForm.report.supporting_docs['monitoring.supporting_docs_group_title__costs_and_services'],
                };

                return data;
            }
        },
        async beforeMount()
        {
            const vm = this;
            vm.moment = require('moment');
            vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

            if (!MonitoringForm.report.hasOwnProperty('show_supporting_documents'))
            {
                MonitoringForm.report.show_supporting_documents = false;
            }

            if (MonitoringForm.report.show_supporting_documents)
            {
                let group_index = 0;

                for (let key in MonitoringForm.report.supporting_docs)
                {
                    MonitoringForm.report.supporting_docs[key].forEach((o) =>
                    {
                        if (o.custom_fields)
                        {
                            for (let i = 0; i < o.custom_fields.length; i++)
                            {
                                if (typeof o.custom_fields[i] === 'string')
                                {
                                    o.custom_fields[i] = {
                                        key: 'support_document_custom_' + group_index + '_' + i,
                                        title: o.custom_fields[i]
                                    };
                                }
                            }
                        }
                    });

                    group_index++;
                }
            }

            vm.startDate = MonitoringForm.report.start_date || '';
            vm.endDate = MonitoringForm.report.end_date || '';
        },
        methods:
        {
            addNewSupportingDocument(subgroup, group_index)
            {
                const last_index = subgroup.custom_fields?subgroup.custom_fields.length:0;
                if(!subgroup.custom_fields){
                    subgroup.custom_fields=[];
                }
                if(!subgroup.fields){
                    subgroup.fields=[];
                }

                subgroup.custom_fields.push({
                    key: 'support_document_custom_' + group_index + '_' + last_index + '_' + (+new Date()),
                    title: '',
                });

                this.$forceUpdate();
            },

            addSupportingDocumentGroup(group, title, subgroup)
            {
                const count = Object.keys(group).length;

                group.push({
                    custom_group: true,
                    title: this.$t(title).replace(/\s*[0-9]?\s*[0-9]\s*$/, '') + ' ' + (count + 1),
                    fields: [].concat(subgroup.fields),
                    custom_fields: []
                });

                this.$forceUpdate();
            },

            showSupportingDocuments()
            {
                MonitoringForm.report.show_supporting_documents = true;
                this.$forceUpdate();
            },

            removeSupportGroup(group, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_group')))
                {
                    group.splice(index, 1);
                }
            },

            removeSupportField(subgroup, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_field')))
                {
                    subgroup.custom_fields.splice(index, 1);
                }
            },

            getError(field)
            {
                return this.errors.first(field);
            },

            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },

            groupDownload(section,currentIndex)
            {
                const payload = {
                    url: `monitoring/report/files-download/${this.reportId}/${section}/${currentIndex}`,
                    method: 'GET'
                };
                FileUploadService.groupDownload(payload).then((resp) => {
                    if(resp.status >= 200 && resp.status <= 300) {
                        window.open(resp.data.download_link, '_blank');
                        // win.focus();
                    }
                }).catch((e) => {
                    swal.fire({
                        title: this.$t('general.notification__warning'),
                        html: e.data.msg,
                        type: 'warning',
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-primary btn-fill',
                        confirmButtonText: 'OK'
                    });
                });
            },
            newDocGroupDownload(section,index)
            {
                const payload = {
                    url: `monitoring/report-new/files-download/${this.reportId}/${section}/${index}`,
                    method: 'GET'
                };
 
                FileUploadService.groupDownload(payload).then((resp) => {
                    if(resp.status >= 200 && resp.status <= 300) {
                        window.open(resp.data.download_link, '_blank');
                        // win.focus();
                    }
                }).catch((e) => {
                    swal.fire({
                        title: this.$t('general.notification__warning'),
                        html: e.data.msg,
                        type: 'warning',
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-primary btn-fill',
                        confirmButtonText: 'OK'
                    });
                });
            },

            fileAdded(file) {
                EventBus.$emit('monitoring-files-add', file);
            }
        },
        watch:
        {
            startDate(new_val)
            {
                MonitoringForm.report.start_date = this.moment(new_val).format('YYYY-MM-DD');
            },
            endDate(new_val)
            {
                MonitoringForm.report.end_date = this.moment(new_val).format('YYYY-MM-DD');
            }
        }
    };
</script>
<style>
.mt-supporting-docs-title
{
    margin-right: 10px;
    margin-bottom: 25px;
    display: inline-block;
}
</style>
